export enum ProjectStatus {
  PENDING = 'PENDING',
  RESERVED = 'RESERVED',
}
